import RoyaltiesNotImplement from "../views/RoyaltiesNotImplement.vue";

const routerRegisters = [
  {
    path: "/royalties/cadastro/acordo-percentuais",
    name: "AgreementPercents",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "AgreementPercents" */ "@/views/Royalties/AgreementPercents/Agreement.vue"
      ),
  },
  {
    path: "/royalties/cadastro/registro-eventos",
    name: "EventLog",
    exact: true,
    component: () =>
      import(
        /* webpackChunckName: "EventLog" */ "@/views/Royalties/EventLog/EventLog.vue"
      ),
  },
  {
    path: "/royalties/cadastro/indicadores-desempenho",
    name: "InsertPerformanceIndicators",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "InsertPerformanceIndicators" */ "@/views/Royalties/InsertPerformanceIndicators/Indicators.vue"
      ),
  },
  {
    path: "/royalties/cadastro/tipos-lancamento",
    name: "FinancialReleaseType",
    exact: true,
    component: () =>
      import(
        /* webpackChunckName: "FinancialReleaseType" */ "@/views/Royalties/FinancialReleaseType/List.vue"
      ),
  },
  {
    path: "/royalties/cadastro/tipos-lancamento/novo",
    name: "FinancialReleaseTypeAdd",
    exact: true,
    component: () =>
      import(
        /* webpackChunckName: "FinancialReleaseTypeForm" */ "@/views/Royalties/FinancialReleaseType/Form.vue"
      ),
  },
  {
    path: "/royalties/cadastro/tipos-lancamento/:id",
    name: "FinancialReleaseTypeEdit",
    exact: true,
    component: () =>
      import(
        /* webpackChunckName: "FinancialReleaseTypeForm" */ "@/views/Royalties/FinancialReleaseType/Form.vue"
      ),
  },
  {
    path: "/royalties/cadastro/motivo-cancelamento-reembolso",
    name: "ReasonCancellationRefund",
    exact: true,
    component: () =>
      import(
        /* webpackChunckName: "ReasonCancellationRefund" */ "@/views/Royalties/ReasonCancellationRefund/List.vue"
      ),
  },
  {
    path: "/royalties/cadastro/motivo-cancelamento-reembolso/novo",
    name: "ReasonCancellationRefundAdd",
    exact: true,
    component: () =>
      import(
        /* webpackChunckName: "ReasonCancellationRefundForm" */ "@/views/Royalties/ReasonCancellationRefund/Form.vue"
      ),
  },
  {
    path: "/royalties/cadastro/motivo-cancelamento-reembolso/:id",
    name: "ReasonCancellationRefundEdit",
    exact: true,
    component: () =>
      import(
        /* webpackChunckName: "ReasonCancellationRefundForm" */ "@/views/Royalties/ReasonCancellationRefund/Form.vue"
      ),
  },
  {
    path: "/royalties/cadastro/motivo-cancelamento-royalties",
    name: "ReasonCancellationRoyalties",
    exact: true,
    component: () =>
      import(
        /* webpackChunckName: "ReasonCancellationRoyalties" */ "@/views/Royalties/ReasonCancellationRoyalties/List.vue"
      ),
  },
  {
    path: "/royalties/cadastro/motivo-cancelamento-royalties/novo",
    name: "ReasonCancellationRoyaltiesAdd",
    exact: true,
    component: () =>
      import(
        /* webpackChunckName: "ReasonCancellationRoyaltiesForm" */ "@/views/Royalties/ReasonCancellationRoyalties/Form.vue"
      ),
  },
  {
    path: "/royalties/cadastro/motivo-cancelamento-royalties/:id",
    name: "ReasonCancellationRoyaltiesEdit",
    exact: true,
    component: () =>
      import(
        /* webpackChunckName: "ReasonCancellationRoyaltiesForm" */ "@/views/Royalties/ReasonCancellationRoyalties/Form.vue"
      ),
  },
  {
    path: "/royalties/cadastro/conciliacao-pedido",
    name: "ConciliationOrder",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "ConciliationOrder" */ "@/views/Royalties/ConciliationOrder/Conciliation.vue"
      ),
  },
  {
    path: "/royalties/cadastro/edicao-notas-conciliadas",
    name: "ConciliationOrderEdit",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "ConciliationOrderEdit" */ "@/views/Royalties/ConciliationOrder/Edit.vue"
      ),
  },
  {
    path: "/royalties/cadastro/auditoria-pedidos",
    name: "AuditOrders",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "AuditOrders" */ "@/views/Royalties/AuditOrders/Audit.vue"
      ),
  },
  {
    path: "/royalties/cadastro/notas-fiscais",
    name: "UploadInvoicesFiles",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "UploadInvoicesFiles" */ "@/views/Royalties/ConciliationOrder/UploadInvoicesFiles.vue"
      ),
  },
];

const routerRoyalties = [
  {
    path: "/royalties/emissao/fatura-individual",
    name: "IndividualInvoice",
    exact: true,
    component: () =>
      import(
        /* webpackChunckName: "IndividualInvoice" */ "@/views/Royalties/Invoice/IndividualInvoice.vue"
      ),
  },
  {
    path: "/royalties/emissao/fatura-grupo",
    name: "GroupInvoice",
    exact: true,
    component: () =>
      import(
        /* webpackChunckName "GroupInvoice" */ "@/views/Royalties/Invoice/GroupInvoice.vue"
      ),
  },
  {
    path: "/royalties/cancelamento/fatura-individual",
    name: "IndividualInvoiceCancellation",
    exact: true,
    component: () =>
      import(
        /* webpackChunckName "IndividualInvoiceCancellation" */ "@/views/Royalties/Invoice/IndividualCancellation.vue"
      ),
  },
  {
    path: "/royalties/cancelamento/fatura-grupo",
    name: "GroupInvoiceCancellation",
    exact: true,
    component: () =>
      import(
        /* webpackChunckName "GroupCancellation" */ "@/views/Royalties/Invoice/GroupCancellation.vue"
      ),
  },
  {
    path: "/royalties/impressao/fatura-individual",
    name: "IndividualInvoicePrinting",
    exact: true,
    component: () =>
      import(
        /* webpackChunckName "IndividualInvoicePrinting" */ "@/views/Royalties/Invoice/IndividualPrinting.vue"
      ),
  },
  {
    path: "/royalties/reembolso/emissao",
    name: "GroupRefund",
    exact: true,
    component: () =>
      import(
        /* webpackChunckName "GroupRefund" */ "@/views/Royalties/Refund/GroupRefund.vue"
      ),
  },
  {
    path: "/royalties/reembolso/cancelamento",
    name: "GroupRefundCancellation",
    exact: true,
    component: () =>
      import(
        /* webpackChunckName "GroupRefundCancellation" */ "@/views/Royalties/Refund/GroupCancellation.vue"
      ),
  },
  {
    path: "/royalties/reembolso/impressao",
    name: "IndividualRefundPrinting",
    exact: true,
    component: () =>
      import(
        /* webpackChunckName "IndividualRefundPrinting" */ "@/views/Royalties/Refund/IndividualPrinting.vue"
      ),
  },
  {
    path: "/royalties/publicacao/contas-receber",
    name: "DonwloadIntegration",
    exact: true,
    component: () =>
      import(
        /* webpackChunckName "DonwloadIntegration" */ "@/views/Royalties/DonwloadIntegration.vue"
      ),
  },
];

const routerPublishes = [
  {
    path: "/royalties/publicacao/publicacao-relatorios",
    name: "ReportPublication",
    exact: true,
    component: () =>
      import(
        /* webpackChunckName "ReportPublication" */ "@/views/Royalties/ReportPublication/Publication.vue"
      ),
  },
  {
    path: "/royalties/publicacao/relacao-documentos",
    name: "FranchisedDocuments",
    exact: true,
    component: () =>
      import(
        /* webpackChunckName "FranchisedDocuments" */ "@/views/Royalties/FranchisedDocuments/Documents.vue"
      ),
  },
  {
    path: "/royalties/publicacao/faturas",
    name: "InvoicePublication",
    exact: true,
    component: () =>
      import(
        /* webpackChunckName "InvoicePublication" */ "@/views/Royalties/InvoicePublication/InvoicePublication.vue"
      ),
  },
];

const routerReports = [
  {
    path: "/royalties/relatorios/notas-reembolso-canceladas",
    name: "ReportRefundCancellation",
    exact: true,
    component: () =>
      import(
        /* webpackChunckName "ReportRefundCancellation" */ "@/views/Royalties/Refund/ReportCancellation.vue"
      ),
  },
  {
    path: "/royalties/relatorios/notas-conciliadas",
    name: "NotesConciliated",
    exact: true,
    component: () =>
      import(
        /* webpackChunckName "NotesConciliated" */ "@/views/Reports/NotesConciliated.vue"
      ),
  },
  {
    path: "/royalties/relatorios/notas-conciliadas-periodo",
    name: "NotesProviderPeriod",
    exact: true,
    component: RoyaltiesNotImplement,
  },
  {
    path: "/royalties/relatorios/contas-receber-franqueado",
    name: "AccountsReceivableFranchisee",
    exact: true,
    component: RoyaltiesNotImplement,
  },
  {
    path: "/royalties/relatorios/situacao-pedido-fornecedor",
    name: "OrderProviderSituation",
    exact: true,
    component: RoyaltiesNotImplement,
  },
  {
    path: "/roylaties/relatorios/comparativo-produtos",
    name: "ComparativeProductReport",
    exact: true,
    component: () =>
      import(
        /* webpackChunckName "ComparativeProductReport" */ "@/views/Reports/ComparisonProducts.vue"
      ),
  },
  {
    path: "/royalties/relatorios/ranking-variacao-franquias",
    name: "RankingFranchiseVariation",
    exact: true,
    component: () =>
      import(
        /* webpackChunckName "RankingFranchiseVariation" */ "@/views/Reports/RankingFranchiseVariation.vue"
      ),
  },
  {
    path: "/royalties/relatorios/ranking-franquias",
    name: "RankingFranchise",
    exact: true,
    component: () =>
      import(
        /* webpackChunckName "RankingFranchise" */ "@/views/Reports/RankingFranchise.vue"
      ),
  },
  {
    path: "/royalties/relatorios/faturamento-mensal-rede",
    name: "MonthlyBillingNetwork",
    exact: true,
    component: () =>
      import(
        /* webpackChunckName "MonthlyBillingNetwork" */ "@/views/Reports/MonthlyBilling.vue"
      ),
  },
  {
    path: "/royalties/relatorios/faturamento-mensal-franqueado",
    name: "MonthlyBillingFranchisee",
    exact: true,
    component: RoyaltiesNotImplement,
  },
];

export default [
  ...routerRegisters,
  ...routerRoyalties,
  ...routerPublishes,
  ...routerReports,
];
